/** 共通の型定義。サーバー・Web の両方から参照される。 */
export const LETTERS = ['A', 'B', 'C', 'D'];
export const DEFAULT_SETTINGS = {
    rounds: 10,
    level: 1,
    hint: true,
    drawSeconds: 26,
    finalSeconds: 5,
    countdownSeconds: 3,
    audioTarget: 'host',
    ttsRate: 1,
    gapMs: 1400,
    listed: false,
    wrongPenalty: 100,
    autoReveal: true,
};
//# sourceMappingURL=types.js.map